import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData, useSitemap, useLabels } from 'wsm-common-data';
import { buildContactUsUrl, trackErrorEvent } from '../util/index';
import {
	GENERIC_ERROR,
	AMP_VEHICLE_OUT_OF_STOCK,
	EXPIRED_OFFER,
	INVALID_OFFER,
	UNKNOWN_ERROR
} from '../server/namespaces';

function Error({ offerData }) {
	const { windowId, widgetName } = useRequestData();
	const sitemap = useSitemap();
	const labels = useLabels();
	const { customer = {}, ssrError } = offerData;
	let firstChunk;
	const contactUs = labels.get('ACCOUNT_LINK_CONTACT');
	const secondChunk = labels.get('FOR_OUR_LATEST_OFFERS');
	switch (ssrError) {
		case AMP_VEHICLE_OUT_OF_STOCK:
			firstChunk = labels.get('AMP_VEHICLE_NO_LONGER_AVAILABLE');
			trackErrorEvent({
				widgetName,
				widgetId: windowId,
				message: 'vehicle not in stock'
			});
			break;
		case EXPIRED_OFFER:
			firstChunk = labels.get('WE_ARE_SORRY_OFFER_EXPIRED');
			trackErrorEvent({
				widgetName,
				widgetId: windowId,
				message: 'offer expired'
			});
			break;
		case INVALID_OFFER:
			firstChunk = labels.get('WE_ARE_SORRY_OFFER');
			trackErrorEvent({
				widgetName,
				widgetId: windowId,
				message: 'offer id invalid'
			});
			break;
		default:
		case UNKNOWN_ERROR:
		case GENERIC_ERROR:
			firstChunk = labels.get('WE_ARE_SORRY_OFFER');
			trackErrorEvent({
				widgetName,
				widgetId: windowId,
				message: 'generic error'
			});
	}

	const contactUrl = buildContactUsUrl(
		sitemap.get('CONTACT_FORM'),
		customer,
		{}
	);
	return (
		<div className="error-container ddc-font-size-xlarge font-weight-normal py-8 px-4 text-black">
			{firstChunk}{' '}
			<button
				type="button"
				data-href={contactUrl}
				className="text-link dialog text-primary"
			>
				{`${contactUs}`}
			</button>
			{` ${secondChunk}`}
		</div>
	);
}

Error.propTypes = {
	offerData: PropTypes.shape()
};

export default Error;
